// extracted by mini-css-extract-plugin
module.exports = {"wfld9tc":"wfld9tc"};